// removed by extract-text-webpack-plugin
module.exports = {"deleteWindow":"LogoutWarning__deleteWindow__8y5wo","deleteTitle":"LogoutWarning__deleteTitle__2KSR2","form":"LogoutWarning__form__KGaEX","button":"LogoutWarning__button__1V3ft","rightIcon":"LogoutWarning__rightIcon__1FHFf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/LogoutWarning/LogoutWarning.css
// module id = 483
// module chunks = 0